import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IEmptyResult } from '../../../httpClient/serverApi/types/IResponse';
import { IIdItem } from '../../../ts/ServerApi/types/resourceParts';

export interface ISetDatasourceRemoteAgentParams extends IIdItem {
  remoteAgentName: string;
  workflowId?: string;
}

export class SetDatasourceRemoteAgentRequest extends Request<ISetDatasourceRemoteAgentParams, IEmptyResult> {
  constructor(params: ISetDatasourceRemoteAgentParams) {
    super('setDatasourceRemoteAgent', params);
  }
}
